import { MapPin, ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Guide = ({ property }) => {
  const { t } = useLang();
  const guide = property?.guide || [];
  if (!guide.length) return null;
  return (
    <section id="guide" className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <p className="text-primary font-medium text-sm uppercase tracking-widest mb-2">{t("Explore the area")}</p>
          <h2 className="font-script text-6xl md:text-8xl leading-tight text-foreground">
            {t("Local favorites")}
          </h2>
          <p className="text-muted-foreground mt-3 max-w-2xl">{t("Handpicked spots around Apache Junction & the Superstition Mountains. Tap any place to learn more and plan your visit.")}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {guide.map((g, i) => {
            const Wrapper = g.link ? "a" : "div";
            const linkProps = g.link ? { href: g.link, target: "_blank", rel: "noopener noreferrer" } : {};
            return (
              <Wrapper
                key={g.title || i}
                data-testid={`guide-${i}`}
                {...linkProps}
                className="group rounded-2xl overflow-hidden bg-accent/50 block transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="h-44 overflow-hidden bg-secondary/20 relative">
                  {g.image ? (
                    <img src={g.image} alt={g.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <MapPin className="h-10 w-10 text-secondary/60" strokeWidth={1.5} />
                    </div>
                  )}
                  {g.link && (
                    <span className="absolute top-3 right-3 h-8 w-8 rounded-full bg-background/85 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <ExternalLink className="h-4 w-4 text-primary" strokeWidth={1.75} />
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-semibold uppercase tracking-wide text-secondary">{t(g.category)}</span>
                    {g.distance && <span className="text-xs text-muted-foreground">{t(g.distance)}</span>}
                  </div>
                  <h3 className="font-serif text-xl font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">{t(g.title)}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{t(g.description)}</p>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};
